import {axios} from '@/utils/request'

// 查询待办任务列表
export function todoList(query) {
  return axios({
    url: '/jeecg-oa/flowable/task/todoList',
    method: 'get',
    params: query
  })
}


// 查询待办任务列表
export function todoListNew(query) {
  return axios({
    url: '/jeecg-oa/flowable/task/todoListNew',
    method: 'get',
    params: query
  })
}

// 查询待签任务列表
export function claimList(query) {
  return axios({
    url: '/jeecg-oa/flowable/task/claimList',
    method: 'get',
    params: query
  })
}

// 签收任务
export function claimTask(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/claim',
    method: 'post',
    data: data
  })
}

// 完成任务
export function complete(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/complete',
    method: 'post',
    data: data
  })
}

// 完成任务
export function completeTask(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/complete',
    method: 'post',
    data: data
  })
}

// 委派任务
export function delegateTask(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/delegate',
    method: 'post',
    data: data
  })
}

//转办任务
export function assignTask(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/assign',
    method: 'post',
    data: data
  })
}

// 退回任务
export function returnTask(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/return',
    method: 'post',
    data: data
  })
}

// 驳回任务
export function rejectTask(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/reject',
    method: 'post',
    data: data
  })
}

// 跳转任务
export function jumpTask(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/jump',
    method: 'post',
    data: data
  })
}

// 跳转任务节点列表
export function userTaskList(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/userTask',
    method: 'post',
    data: data
  })
}

// 加签任务
export function addSignTask(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/addSign',
    method: 'post',
    data: data
  })
}

// 多实例加签任务
export function multiInstanceAddSignTask(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/multiInstanceAddSign',
    method: 'post',
    data: data
  })
}

// 可退回任务列表
export function returnList(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/returnList',
    method: 'post',
    data: data
  })
}

// 下一节点 todo 目前直接自动分配到候选人，不用主动选人，如有需要再开发
export function getNextFlowNode(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/nextFlowNode',
    method: 'post',
    data: data
  })
}

// 下一个节点 是否是通用同意拒绝排它网关，这个要做特殊处理
export function nextApprovedEG(taskId) {
  return axios({
    url: '/jeecg-oa/flowable/task/nextApprovedEG',
    method: 'post',
    params: taskId
  })
}

// 查询流程定义详细
export function getDeployment(id) {
  return axios({
    url: '/system/deployment/' + id,
    method: 'get'
  })
}

// 新增流程定义
export function addDeployment(data) {
  return axios({
    url: '/system/deployment',
    method: 'post',
    data: data
  })
}

// 修改流程定义
export function updateDeployment(data) {
  return axios({
    url: '/system/deployment',
    method: 'put',
    data: data
  })
}

// 删除流程实例
export function delDeployment(id,dataid) {
  return axios({
    url: '/jeecg-oa/flowable/instance/delete/?instanceId=' + id + '&dataId=' + dataid,
    method: 'delete'
  })
}

// 导出流程定义
export function exportDeployment(query) {
  return axios({
    url: '/system/deployment/export',
    method: 'get',
    params: query
  })
}
